import axios from "../../axios";

export const getCategories = async (accountId, aggregated = false) => {
    try {
      const url = aggregated ? `/api/v3/aggregate/analysis/categories?reportReferenceId=${accountId}` : `/api/v3/analysis/categories?accountId=${accountId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw new Error(JSON.stringify(error));
    }
};